// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"531e77d1","448":"f5c9dfcb","455":"b14964d0","497":"8b520d4f","645":"1793a7b5","738":"0f9e02cb","977":"2caed02d"}[chunkId] + ".chunk.js";
};